
export namespace UrlUtil {
    export const ACCESSORY_VARIATION_PREFIX = 'av_';
    export const VARIATION_PREFIX = 'v_';
    export const FACET_PREFIX: string = 'facet_';
    export const SORT_PREFIX: string = 'sorting';
    export const REPLACE_PREFIX: string = 'replace';
    export const SEARCH_PREFIX: string = 'searchTerms';
    export const INTERVAL_PREFIX: string = 'interval';
    export const PAGE_PREFIX: string = 'page';
    export const STEP_PREFIX: string = 'step';
    const prefixList = [ACCESSORY_VARIATION_PREFIX,VARIATION_PREFIX, FACET_PREFIX, SORT_PREFIX, SEARCH_PREFIX, PAGE_PREFIX, INTERVAL_PREFIX,STEP_PREFIX];


    export function safeUrl(search: URLSearchParams, url?: URL): URL {
        var currentUrl = url ?? new URL(window.location.href);

        Array
            .from(currentUrl.searchParams.keys())
            .forEach(key => prefixList.some(p =>
                key.startsWith(p)) ? currentUrl.searchParams.delete(key) : null
            );
        Array
            .from(search.entries())
            .filter(([key, value]) => value != null && value != '')
            .forEach(([key, value]) => currentUrl.searchParams.append(key, value));


        return currentUrl;
    }
}
